export const Header2 = `<div class=" experience-details">
					<div class="experience-role"></div>
            <div class="experience-inner-details">
			<span  class="experience-company"></span>
			<span class="experience-date"></span>
			<span  class="experience-location"></span>
            </div>
        </div><div  class="experience-description"></div>`;
